<div class="ct-overlay">
  <div class="ct-modal">
    <img class="cm-icon" src="assets/icons/error-triangle.svg" alt="" />
    <p class="cm-msg-one">
      {{ erroMessage | translate }}
    </p>
    <div class="cm-btn-grp">
      <button (click)="onClickRefresh('tryAgain')" class="cm-btn-dark">
        {{ "TryAgain" | translate }}
        <img class="arrow-right-icon" src="assets/icons/arrow-right.svg" alt="" />
      </button>
      <button (click)="onClickRefresh('Cancel')" class="cm-btn-light">
        {{ "Cancel" | translate }}
      </button>
    </div>
  </div>
</div>
